


































































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import CoinModule from '@/store/modules/Coin';
import ReportModule from '@/store/modules/Report';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import CoinBody from '@/components/Table/CoinBody.vue';
import LogBody from '@/components/Table/CoinLogBody.vue';
import Pagination from '@/components/Pagination.vue';
import CoinData from '@/data/CoinData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import ProductDropdown from '@/components/ProductDropdown.vue';
import { IPointCriteria } from '@/interface/pointReport';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    CoinBody,
    LogBody,
    ProductDropdown,
  },
})
export default class Coin extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  AuthInstance = getModule(AuthModule, this.$store);

  CoinInstance = getModule(CoinModule, this.$store);

  ReportInstance = getModule(ReportModule, this.$store);

  Criteria: IPointCriteria = {
    ...this.Period,
    isSearch: false,
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    limit: 100,
    page: 1,
  };

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  type = '';

  resultData: object = {};

  dataList: any = [];

  LoginName = '';

  TableHeadMember = [...CoinData.TableHeadMember];

  FilteredTableHeadMember: Array<object> = [...CoinData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  isMember = false;

  startDate = '';

  endDate = '';

  isSuperadmin = false;

  footSummery: object = {};

  isSearch = false;

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  pointFetch = 'member';

  personLog = {};

  totalCount = 0;

  summaryWinlose = 0;

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchPeriodStart() {
    const _startDate = this.$moment(this.Period.start.date).startOf('day').toDate();
    this.startDate = _startDate;
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchPeriodEnd() {
    const _endDate = this.$moment(this.Period.end.date).endOf('day').toDate();
    this.endDate = _endDate;
  }

  created() {
    this.BreadcrumbList = this.BreadcrumbDefault;
    this.isSuperadmin = ['SUPERADMIN'].includes(this.AuthInstance.user.role);
    this.fetchCoin();
  }

  handleSubmit() {
    this.Period.start.date = this.startDate;
    this.Period.end.date = this.endDate;
    this.fetchCoin();
  }

  initial() {
    this.currentTool = 'Today';
    this.Criteria = {
      ...this.Period,
      isSearch: false,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      limit: 100,
      page: 1,
    };
    this.LoginName = '';
    this.isMember = false;
  }

  async fetchCoin() {
    this.Criteria.isSearch = !!this.LoginName;
    this.pointFetch = 'member';
    this.mode = 'agent';
    this.FilteredTableHeadMember[0] = [...CoinData.TableHeadMember[0]];
    this.GeneralInstance.toggleLoading(true);
    const result = await this.CoinInstance.FetchCoinReport({
      ...this.Period,
      ...this.Criteria,
      page: this.PaginationDetail.current,
    });
    if (result.data) {
      this.PaginationDetail.amount = result.pageAmount;
      this.resultData = result.data.map((value, idx) => ({
        ...value,
        index: idx + ((this.PaginationDetail.current - 1) * 100) + 1,
      }));
      this.footSummery = result.footerSummary;
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...result.breadcrumb];
      this.GeneralInstance.toggleLoading(false);
    } else {
      this.checkError(result.status);
      this.GeneralInstance.toggleLoading(false);
    }
    this.isSearch = false;
  }

  async fetchResult(params) {
    const {
      roundId,
      product,
      category,
    } = params;
    const width = (category === 'arcade' && product !== 'PUNPAE')
      || product === 'BINGO'
      || product === 'BINGO2'
      ? 1305
      : 700;
    const height = category === 'arcade' || product === 'BINGO' || product === 'BINGO2'
      ? 630
      : 750;
    const strWindowFeatures = `top=0,left=0,height=${height},width=${width},scrollbars=yes`;
    const param = {
      roundId,
      language: this.$i18n.locale,
    };
    const res = await this.ReportInstance.FetchTransaction(param);
    window.open(res.url, 'gameResult', strWindowFeatures);
  }

  onSubmit() {
    if (this.pointFetch === 'member') {
      this.fetchCoin();
    } else {
      this.fetchCoinLog(this.personLog);
    }
  }

  changePage(i: number) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    if (this.pointFetch === 'member') {
      this.fetchCoin();
    } else {
      this.fetchCoinLog(this.personLog);
    }
  }

  handleSearch() {
    this.PaginationDetail.current = 1;
    this.Criteria.username = this.LoginName;
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
    this.isSearch = true;
  }

  handleFetchCoinAgent(data: object) {
    this.beforeFetch(data);
  }

  handleBreadcrumb(data: object) {
    this.beforeFetch(data);
  }

  beforeFetch(data: any = {}) {
    this.isMember = data.role === 'MEMBER';
    this.LoginName = '';
    this.Criteria.username = data.username;
    this.Criteria.source = data.source;
    this.Criteria.role = data.role;
    this.Criteria.userId = data.id || data.userId || data._id;
    this.PaginationDetail.current = 1;
    if (this.isMember) {
      this.fetchCoinLog(data);
    } else {
      this.fetchCoin();
    }
  }

  async fetchCoinLog(data: object) {
    this.personLog = data;
    this.pointFetch = 'log';
    if (this.isMember) {
      this.mode = 'member';
    }
    this.FilteredTableHeadMember[0] = [...CoinData.TableHeadLog[0]];
    this.GeneralInstance.toggleLoading(true);
    const logReward = await this.CoinInstance.FetchCoinLog({
      ...this.Period,
      data,
      page: this.PaginationDetail.current,
      limit: 100,
    });
    this.PaginationDetail.amount = logReward.pageAmount;
    this.resultData = logReward.data;
    this.totalCount = logReward.count;
    this.summaryWinlose = logReward.summaryWinlose;
    this.BreadcrumbList = [...this.BreadcrumbDefault, ...logReward.breadcrumb];
    this.GeneralInstance.toggleLoading(false);
    this.isSearch = false;
  }
}
